module.exports = __webpack_public_path__ + "img/xtwj.9e1d1cb5.png";